import * as React from 'react';
import styles from './index.css';
import { Box } from 'src/lib/StyledComponents';

const RoundedRectangleButton = props => {
	const { onClick, disabledBackgroundColor, disabledColor, disabled, ...others } = props;

	const propStyles = {
		...others,
		...(disabled && disabledBackgroundColor
			? { backgroundColor: disabledBackgroundColor }
			: {}),
		...(disabled && disabledColor ? { color: disabledColor } : {}),
	};

	return (
		<Box
			{...propStyles}
			className={`${styles.RoundedRectangleButton} ${props.className}`}
			onClick={props.onClick}
		>
			{props.children}
		</Box>
	);
};

export default RoundedRectangleButton;



// WEBPACK FOOTER //
// ./src/components/RoundedRectangleButton/index.js